// Keeps the document's <link rel="canonical"> tag aligned with the
// current route as the React Router navigates. Without this, the
// static canonical baked into index.html ("https://petzy.ro/") would
// stay attached to every SPA route — Google reads that as "every URL
// on this site has the same canonical content as the homepage" and
// de-prioritises indexing for sub-routes like /salon/:slug, which
// are the most SEO-valuable pages on Petzy (long-tail per-salon
// queries).
//
// Strips query string and hash from the canonical: filter params
// like ?city=Cluj or ?category=BATH_BRUSH change the displayed
// salon list but not the underlying content URL, and consolidating
// them all under the bare /search or / lets ranking accumulate
// instead of fragmenting across permutations.
//
// Side-effect only. Returns nothing. Call once near the App root.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://petzy.ro';

// Accepts an optional location override so the caller can sync the
// canonical update with a trailing view-transition location instead of
// the live one; falls back to useLocation() when omitted.
export default function useCanonical(locationOverride) {
  const current = useLocation();
  const { pathname } = locationOverride ?? current;

  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = SITE_URL + pathname;
  }, [pathname]);
}
